import { MeasurementRequestStatus, WaferStatus } from "@/types/measurementRequest";

// Wafer status styling: Soft, rounded pill design for operational states
export const getWaferStatusColor = (status: WaferStatus) => {
  switch (status) {
    case "TO_SCHEDULE":
      return "bg-slate-50 text-slate-600 border-slate-200 rounded-full";
    case "SCHEDULED":
      return "bg-sky-50 text-sky-700 border-sky-200 rounded-full";
    case "MEASURING":
    case "MEASURED":
      return "bg-amber-50 text-amber-700 border-amber-200 rounded-full";
    case "ANALYSING":
      return "bg-indigo-50 text-indigo-700 border-indigo-200 rounded-full";
    case "ANALYSED":
      return "bg-emerald-50 text-emerald-700 border-emerald-200 rounded-full";
    case "ANALYSIS_FAILED":
    case "MEASURING_FAILED":
      return "bg-red-50 text-red-700 border-red-200 rounded-full";
    default:
      return "bg-slate-50 text-slate-600 border-slate-200 rounded-full";
  }
};

export const formatWaferStatus = (status: WaferStatus) => {
  switch (status) {
    case "TO_SCHEDULE":
      return "To Schedule";
    case "SCHEDULED":
      return "Scheduled";
    case "ANALYSED":
      return "Analysed";
    case "ANALYSING":
      return "Analysing";
    case "ANALYSIS_FAILED":
      return "Analysis Failed";
    case "MEASURING":
      return "Measuring";
    case "MEASURED":
      return "Measured";
    case "MEASURING_FAILED":
      return "Measuring Failed";
    default:
      return "Unknown";
  }
};

// Measurement request status styling: Bold, angular design for workflow states
export const getMeasurementRequestStatusColor = (status: MeasurementRequestStatus) => {
  switch (status) {
    case "TO_DO":
      return "bg-blue-500 text-white border-blue-600 font-semibold shadow-sm";
    case "PARTIALLY_PLANNED":
      return "bg-orange-500 text-white border-orange-600 font-semibold shadow-sm";
    case "PLANNED":
      return "bg-purple-500 text-white border-purple-600 font-semibold shadow-sm";
    case "MEASURING":
      return "bg-amber-500 text-white border-amber-600 font-semibold shadow-sm";
    case "EXECUTED":
      return "bg-green-500 text-white border-green-600 font-semibold shadow-sm";
    case "ANALYSING":
      return "bg-indigo-600 text-white border-indigo-700 font-semibold shadow-sm";
    case "ANALYSED":
      return "bg-gray-600 text-white border-gray-700 font-semibold shadow-sm";
    case "ANALYSIS_FAILED":
      return "bg-red-600 text-white border-red-700 font-semibold shadow-sm";
    default:
      return "bg-gray-600 text-white border-gray-700 font-semibold shadow-sm";
  }
};

export const measurementRequestStatusMapping = {
  TO_DO: "Not Yet Scheduled",
  PARTIALLY_PLANNED: "Partially Scheduled",
  PLANNED: "Scheduled",
  MEASURING: "Measuring",
  EXECUTED: "Measured",
  ANALYSING: "Analysing",
  ANALYSED: "Analysed",
  ANALYSIS_FAILED: "Analysis Failed",
};
